
import * as angular from "angular";

import { DriverService } from "@services/driver.service";

export interface IDriverUsernameScope extends angular.IScope {
    driverUsername: string;
}

export class DriverUsernameDirective implements angular.IDirective {

    restrict = 'A';
    require = 'ngModel';
    scope = { driverUsername: "<" }

    static $inject = ['$window', 'driverService', "$q"];
    constructor(private $window: angular.IWindowService, private driverService: DriverService, private $q: angular.IQService) { }

    link(scope: IDriverUsernameScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) {

        ngModel.$asyncValidators["driverUsername"] = modelValue => {
            if (scope.driverUsername === modelValue) {
                return this.$q.resolve();
            }
            return this.driverService.isDriverUsernameInUse(modelValue).then(result => {
                if (result) {
                    return this.$q.reject("User name is in use");
                }

                return this.$q.resolve();
            });
        };
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($window: angular.IWindowService, driverService: DriverService, $q: angular.IQService) => new DriverUsernameDirective($window, driverService, $q);
        directive.$inject = ['$window', 'driverService', "$q"];
        return directive;
    }

}
